import classNames from 'classnames';
import PropTypes from 'prop-types';
import React from 'react';
import styled from 'styled-components';

import CaretLeftIcon from '@icons/CaretLeftIcon';
import { ButtonLightLarge, ButtonPrimaryLarge } from '@styled';
import { mediaQueries } from '@general/breakpoints';
import colors from '@general/colors';

const ContainerStyled = styled.div`
    box-shadow: 0px -1px 6px rgba(0, 0, 0, 0.16);
    padding-bottom: 22px;
    padding-top: 22px;

    position: sticky;
    background-color: ${colors.white};
    bottom: 0;
`;

const PreviousButtonStyled = styled(ButtonLightLarge)`
    @media ${mediaQueries.smDown} {
        padding: 14px 30px;
    }
`;

const NextButtonStyled = styled(ButtonPrimaryLarge)`
    @media ${mediaQueries.smDown} {
        padding: 14px 30px;
    }
`;

const FooterNavigation = ({
    nextButtonDisabled = false,
    nextLabel,
    previousButtonDisabled = false,
    previousLabel,
    showPreviousCaret = false,
    onNextClick,
    onPreviousClick,
}) => {
    return (
        <ContainerStyled>
            <div className="container">
                <div className="flex justify-between">
                    {previousLabel && onPreviousClick && (
                        <PreviousButtonStyled
                            className="d-flex items-center"
                            disabled={previousButtonDisabled}
                            type="button"
                            onClick={() => onPreviousClick()}
                        >
                            {showPreviousCaret && <CaretLeftIcon />}
                            <span className={classNames({ 'ml-1rem': showPreviousCaret })}>{previousLabel}</span>
                        </PreviousButtonStyled>
                    )}

                    {(!previousLabel || !onPreviousClick) && <div />}

                    <NextButtonStyled disabled={nextButtonDisabled} type="button" onClick={() => onNextClick()}>
                        {nextLabel}
                    </NextButtonStyled>
                </div>
            </div>
        </ContainerStyled>
    );
};

FooterNavigation.propTypes = {
    nextButtonDisabled: PropTypes.bool,
    nextLabel: PropTypes.string.isRequired,
    previousButtonDisabled: PropTypes.bool,
    previousLabel: PropTypes.string,
    showPreviousCaret: PropTypes.bool,
    onNextClick: PropTypes.func.isRequired,
    onPreviousClick: PropTypes.func,
};

export default FooterNavigation;
